module.exports = __webpack_public_path__ + "img/___bg.64c295b1.jpg";